<template v-if="product" >
  <div v-if="category.ProductID" class="item" style="cursor:pointer" @click="showModal" :class="{'curved' : isSushi}">
    <div   :style="isSushi &&  'height: 150px'">
      <div :class="{ 'with-image': getProductImage(product) }" class="item-details">
        <h5 class="item-title"  :class="{'montserrat-600  text-black' : isSushi}">{{ getProductName() }}</h5>
        <p
            :title="product.ShortDescription"
            class="block-with-text"
            :class="{'montserrat-400 ' : isSushi}"
            v-html="getProductDescription()"
        ></p>


      </div>
      <div class="item-price d-flex container" :style="isSushi && 'height: 3rem'">
        <h3 :class="{'montserrat-700 text-black' :isSushi  } " v-if="category.Price > 0">{{ category.Price | formatMoney(currencySign) }}</h3>
        <ul>
          <li
              v-for="(dietary, index) in dietaryList"
              :key="index"
              :style="getIconStyle(dietary)"
              :title="dietary.Name"
          ></li>
        </ul>



      </div>

    </div>

    <div class="container pt-2" v-if="isSushi">
      <h3 class="montserrat-700 sushi-red" style="font-size: 13px">{{ $t('message.addToCart').toUpperCase() + ' >' }}</h3>

    </div>




    <div
        v-lazy:background-image="getProductImage(product)"
        :style="imageRatioStyle"
        :class="isSushi ? 'item-img-sushi' : 'item-img'"
    />
    <img
        v-lazy="getProductImage(product)"
        style="display:none"
        class="item-img"
        @error="imgHttpError"
        alt="productImage"
    />
    <div v-if="status === undefined"
      :class="{
        new: product.Status === 1,
        popular: product.Status === 2,
        sold: product.Status === 3,
        'montserrat-700': isSushi,
      }"
        class="ibadge"
    >{{ formatStatus(product.Status , this) }}</div>
    <div v-else
      :class="{
        new: status === 1,
        popular: status === 2,
        sold: status === 3,
        'montserrat-700': isSushi,
      }"
      class="ibadge"
    >{{ formatStatus(status , this) }}</div>
    <AddToCart
        v-if="isModalVisible"
        :price="category.Price"
        :category="category"
        :parent-category="parentCategory"
        :product="product"
        :modifiers="modifiers"
        :image-styles="dialogImageRatioStyle"
        :isSushi="isSushi"
    />
  </div>
</template>



<script>
import shared from "../../../sharedscripts/shop/products/Product.js";
import AddToCart from "./AddToCart.vue";
import sharedTranslations from "@/sharedscripts/shop/products/Translations";
export default {
  name: "Product",
  components: {
    AddToCart,
  },
  filters: {
    ...shared.filters
  },
  props: {
    product: {
      type: Object,
      default: () => {}
    },
    category: {
      type: Object,
      default: () => {}
    },
    parentCategory: {
      type: Object,
      default: () => {}
    },
    modifiers: {
      type: Object,
      default: () => {}
    },
    sectionId: {
      type: Number,
      default: 0
    },
    isSushi : {
      type : Boolean
    },
    status: {
      type: Number,
    }
  },
  data() {
    return {
      isModalVisible: false,
      width: 0,
      height: 0
    };
  },
  computed: {
    ...shared.computed
  },
  mounted() {
    this.getImageWidthHeight();
  },
  methods: {
    ...shared.methods,
    ...sharedTranslations.methods,
    imgHttpError(event) {
      if (event && event.target && event.target.style)
        event.target.style.display = "none";
    },
    formatStatus(value, vueObj) {
      let that = vueObj;
      let pricing;
      switch (value) {
        case 1:
          pricing = that.$t("message.new");
          break;
        case 2:
          pricing = that.$t("message.popular");
          break;
        case 3:
          pricing = that.$t("message.soldOut");
          break;
        default:
          pricing = "";
          break;
      }
      return pricing;
    },
    getProductImage(product) {
      if (product.PhotoUrl) return product.PhotoUrl;
      else return null;
    }
  }
};
</script>
